// extracted by mini-css-extract-plugin
export default {"tableWrapper":"table_tableWrapper__Pw4pX"};